import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'DashboardIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    boxSize: 6,
  },
  path: (
    <>
      <path
        d="M3.75 6C3.75 4.75736 4.75736 3.75 6 3.75H8.25C9.49264 3.75 10.5 4.75736 10.5 6V7C10.5 8.24264 9.49264 9.25 8.25 9.25H6C4.75736 9.25 3.75 8.24264 3.75 7V6Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M3.75 14.5C3.75 13.2574 4.75736 12.25 6 12.25H8.25C9.49264 12.25 10.5 13.2574 10.5 14.5V18C10.5 19.2426 9.49264 20.25 8.25 20.25H6C4.75736 20.25 3.75 19.2426 3.75 18V14.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M13.5 6C13.5 4.75736 14.5074 3.75 15.75 3.75H18C19.2426 3.75 20.25 4.75736 20.25 6V9.5C20.25 10.7426 19.2426 11.75 18 11.75H15.75C14.5074 11.75 13.5 10.7426 13.5 9.5V6Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M13.5 17C13.5 15.7574 14.5074 14.75 15.75 14.75H18C19.2426 14.75 20.25 15.7574 20.25 17V18C20.25 19.2426 19.2426 20.25 18 20.25H15.75C14.5074 20.25 13.5 19.2426 13.5 18V17Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        fill="none"
      />
    </>
  ),
});
